var _a;
/**
 * Consolidating all routes on this file
 */
import { PORTAL_ROUTE_PREFIX } from './values';
var ROUTE_NAMES;
(function (ROUTE_NAMES) {
    ROUTE_NAMES["CONTACT_SALES"] = "CONTACT_SALES";
})(ROUTE_NAMES || (ROUTE_NAMES = {}));
export var ROUTES = (_a = {},
    _a[ROUTE_NAMES.CONTACT_SALES] = PORTAL_ROUTE_PREFIX + "/contact-sales",
    _a);
